import { render } from "./HelpfulIndex.vue?vue&type=template&id=6cef3df4"
import script from "./HelpfulIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpfulIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/helpful/components/HelpfulIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cef3df4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cef3df4', __exports__)) {
    api.reload('6cef3df4', __exports__)
  }
  
  module.hot.accept("./HelpfulIndex.vue?vue&type=template&id=6cef3df4", () => {
    api.rerender('6cef3df4', render)
  })

}


export default __exports__